<!-- @format -->

<template>
  <Accordion title="Dados da Aquisição">
    <Grid cols4 gap5>
      <InputNumber v-if="route.params.id" label="Código" placeholder="Insira Código" v-model="localValue.id" :disabled="route.params.id" />
      <Select :items="type" v-model="localValue.type" disabled label="Tipo" required :error="localErrors.type" />
      <InputZoom
        required
        clearable
        label="Local Destino"
        placeholder="Selecione o Destino"
        :error="localErrors.idDestinationWarehouse"
        v-model="localValue.idDestinationWarehouse"
        :filter="[{ column: 'type', operator: '=', value: 'physic' }]"
        database="warehouse"
        item-value="id"
        item-text="name"
        :disabled="readMode" />

      <InputDateTime v-model="localValue.acquisitionDate" label="Data de Lançamento" placeholder="Insira a Data de Lançamento" required :error="localErrors.acquisitionDate" timeStamp disabled />
      <InputText v-model="localValue.orderNumber" label="Número do pedido" placeholder="Número do pedido" :error="localErrors.orderNumber" :disabled="readMode" />
      <InputZoom label="Protocolo do pedido" v-model="localValue.orderProtocol" placeholder="Selecione o Protocolo" :error="localErrors.orderProtocol" database="os" item-value="protocolo" item-text="address" :disabled="readMode" />

      <Select clearable v-model="localValue.orderType" label="Tipo do pedido" placeholder="ICL/Pontual" :items="orderType" :error="localErrors.orderType" :disabled="readMode" />

      <InputZoom v-model="localValue.idItemType" :error="localErrors.idItemType" database="itemType" item-value="id" item-text="name" label="Tipo de Material" placeholder="Selecione o Tipo do Material" clearable :disabled="readMode" />

      <InputZoom
        v-model="localValue.idConstructionProjectType"
        :error="localErrors.idConstructionProjectType"
        database="constructionProjectType"
        item-value="id"
        item-text="name"
        label="Tipo de Obra"
        placeholder="Selecione o Tipo da Obra"
        clearable
        :disabled="readMode" />

      <InputZoom v-model="localValue.idContract" :error="localErrors.idContract" database="contract" item-value="id" item-text="name" label="Contrato" placeholder="Selecione o Contrato" clearable :disabled="readMode" />

      <InputZoom
        v-model="localValue.idPriceTable"
        :error="localErrors.idPriceTable"
        database="priceTable"
        item-value="id"
        item-text="name"
        label="Tabela de Preço"
        placeholder="Selecione uma Tabela de Preço da Aquisição"
        clearable
        :disabled="readMode" />
      <InputText v-model="localValue.listCode" :error="localErrors.idPriceTable" placeholder="Insira o Número da lista" label="Número da lista" :disabled="readMode" />

      <SwitchButton v-if="!localValue.id" v-model="localValue.status" label="Material Já Recebido" class="mt-4" :disabled="readMode" />
      <InputText v-if="localValue.type === 'entry'" v-model="localValue.approverName" placeholder="Recebido por" label="Recebido Por" disabled />
      <InputDateTime v-if="localValue.type === 'entry'" v-model="localValue.date" label="Data do Recebimento" placeholder="Data do Recebimento" disabled />

      <TextArea class="col-span-4" v-model="localValue.description" label="Observações" placeholder="Observações da Aquisição" :error="localErrors.description" :disabled="readMode" />
    </Grid>
  </Accordion>
  <Accordion title="Dados Fiscais">
    <Grid cols4 gap5>
      <InputZoom clearable v-model="localValue.idSupplier" label="Fornecedor" database="supplier" item-text="name" item-value="id" placeholder="Selecione o Fornecedor" :error="localErrors.idSupplier" required :disabled="readMode" />

      <InputText v-model="localValue.nfeKey" label="Chave de Acesso Nota Fiscal" placeholder="Insira a Chave de acesso nota Fiscal" :error="localErrors.nfeKey" :disabled="readMode" />

      <InputText v-model="localValue.ntm" label="Número Nota Fiscal" placeholder="Insira o Número de Nota fiscal" required :error="localErrors.ntm || localErrors.duplicateEntry" :disabled="readMode" />

      <InputDateTime v-model="localValue.nfeDate" label="Data Emissão da Nota Fiscal" placeholder="Insira a data da Emissão da Nota Fiscal" required :error="localErrors.nfeDate" :disabled="readMode" />
    </Grid>
  </Accordion>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useFormat } from '@/composables/useFormat'
import InputNumber from '../../molecules/InputNumber.vue'
import InputText from '../../molecules/InputText.vue'

const { formatFullDate, formatDatetimeToTimezone } = useFormat()

const store = useStore()
const route = useRoute()

const orderType = [
  { label: 'ICL', value: 1 },
  { label: 'Pontual', value: 2 },
]
const acquisitionConfirmed = defineModel('acquisitionConfirmed', Boolean)
const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])
const type = ref([
  { label: 'Aquisição', value: 'acquisition' },
  { label: 'Entrada', value: 'entry' },
])
const localValue = ref()
const localErrors = ref(props.error)

const readMode = computed(() => {
  return localValue.value.type !== 'acquisition'
})

const user = computed(() => store.state.user)

// campos readonly
const confirmationDate = computed(() => {
  if (localValue.value.date) {
    return formatFullDate(localValue.value.date)
  }
  return false
})

const confirmationDetails = computed(() => {
  if (confirmationDate.value) {
    return `${user.value.name} - ${confirmationDate.value}`
  }
})

// Watchers

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
    if (!route.params.id) {
      localValue.value.type = 'acquisition'
    }
  },
  { deep: true, immediate: true },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)
watch(
  localValue.value,
  (newValue) => {
    emits('update:modelValue', newValue)
  },
  { deep: true },
)
</script>
